const { default: axiosIns } = require('@/libs/axios')

const ForecastSevice = {
  // GET - ForecastAPIController
  async prepareForecastWrapper(accountId) {
    return axiosIns.get(`/forecast/prepare?accountId=${accountId}`).then(response => response.data)
  },
  // POST - ForecastAPIController
  async getForecast(accountId, model) {
    return axiosIns.post(`/forecast?accountId=${accountId}`, model).then(response => response.data)
  },
}

export default ForecastSevice
